// This helper provides some utility methods to send events to google tag manager
// More information can be found docs/README-GOOGLE_TAG_MANAGER.md

export function dataLayerPush(
  eventType = "dataLayerPushNoEventType",
  dataLayerVariables = {},
) {
  // This is the way to send custom events to google tag manager
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventType,
    ...dataLayerVariables,
  });
}

export function gtmPushCustomEvent(
  eventCategory,
  eventAction,
  eventLabel,
  eventValue,
) {
  // The following variables need to correlate with the variables defined in the google tag manager
  const eventType = "customEvent";
  const dataLayerVariables = {
    eventCategory: eventCategory || "noEventCategory",
    eventAction: eventAction || "noEventAction",
    eventLabel: eventLabel || "noEventLabel",
    eventValue: eventValue || "noEventValue",
  };
  dataLayerPush(eventType, dataLayerVariables);
}

export function gtmPushTrackPageview(location) {
  // The following variables need to correlate with the variables defined in the google tag manager
  const eventType = "customPageView";
  const dataLayerVariables = {
    location,
  };
  dataLayerPush(eventType, dataLayerVariables);
}
